<template>
    <div :id="'radio--' + component_id">
        <div class="designeroption" v-if="options_loaded && passed_filter" :data-designer-component-id="component_id">
            <h3>Add Secured By Design To Your Door</h3>
            <div class="stylesoption align-center">
                <img :src="'/images/wb/sbd.png'" alt="">
                <div class="radiooption mt-6">
                    <span>Would you like to upgrade to SBD?</span>
                    <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                               :name="'radio_' + component_id"
                                                                               :value="option.value"/> {{ option.label }}</label></span>
                </div>
            </div>
        </div>
    </div>


</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSecuredByDesign from "../DesignerQuestionSecuredByDesign.vue";

    export default {
        mixins: [
            DesignerQuestionSecuredByDesign
        ],
        props: {
            slab: {
                required: true,
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab);
            },
            url(){
                return '/api/options/' + this.fabricator + '/secured-by-design?slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.slab;
            },
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
